module.exports = __webpack_public_path__ + "img/w2.a90ef06a.png";